import { Box, Tab, Tabs, Typography } from "@mui/material";
import { ReactNode, useContext, useState } from "react";
import { MainContextState, MainContext } from "../../../../context/MainContext";
import TabPanel from "../../../TabPanel/TabPanel";
import { ReportTableCreator } from "./ReportTableCreator";
import { form11HeaderCells, form11Rows } from "../helpers/form11";
import { form1HeaderCells, form1Rows } from "../helpers/form1";
import { form2Rows, form2HeaderCells } from "../helpers/form2";

interface IProps {
    editForm?: boolean;
}

export const Form1EditForm = ({ editForm = false }: IProps) => {
    const [tab, setTab] = useState(1);

    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        setTab(newValue);
    };

    const { constants } = useContext<Partial<MainContextState>>(MainContext);

    const isOwner =
        localStorage.getItem("employee_type") == "16" &&
        localStorage.getItem("employee_center_id") == localStorage.getItem("current_center_id");

    return (
        <>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs value={tab} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label="Форма 1" value={1} />
                    <Tab label="Приложение к отчету Ф1" value={2} />
                    <Tab label="Форма 2" value={3} />
                </Tabs>
            </Box>
            <TabPanel index={1} value={tab}>
                <Box sx={{ p: 2 }}>
                    <Typography variant="h5" fontWeight={"bold"} textAlign={"left"}>
                        Форма 1
                    </Typography>
                    <Typography variant="body2" textAlign={"left"}>
                        ОБЕСПЕЧЕН МОНИТОРИНГ РЕАЛИЗАЦИИ СООТВЕТСТВУЮЩЕГО ПРОЕКТА (В ЧАСТИ МЕРОПРИЯТИЯ (РЕЗУЛЬТАТА)
                        СООТВЕТСТВУЮЩЕГО ПРОЕКТА)
                    </Typography>
                </Box>
                <ReportTableCreator bodyCell={form1Rows} headerCell={form1HeaderCells} />
            </TabPanel>
            <TabPanel index={2} value={tab}>
                <Box sx={{ p: 2 }}>
                    <Typography variant="h5" fontWeight={"bold"} textAlign={"left"}>
                        Приложение к отчету "Форма1"
                    </Typography>
                </Box>

                <ReportTableCreator bodyCell={form11Rows} headerCell={form11HeaderCells} />
            </TabPanel>
            <TabPanel index={3} value={tab}>
                <Box sx={{ p: 2 }}>
                    <Typography variant="h5" fontWeight={"bold"} textAlign={"left"}>
                        Форма 2
                    </Typography>
                </Box>
                <ReportTableCreator bodyCell={form2Rows} headerCell={form2HeaderCells} />
            </TabPanel>
        </>
    );
};
